module.exports = __webpack_public_path__ + "static/10-014e9a655d35f8f55dbb7201726f58da.jpg";